export type UrchinTrackingModule = {
  utmCode: string;
  utm_source: string;
  utm_medium: string;
  utm_term: string;
  utm_campaign: string;
  utm_content: string;
};

export type WithUrchinTrackingModule = Partial<UrchinTrackingModule>;

export const UTM_KEYS = [
  'utmCode',
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_campaign',
  'utm_content',
];
